<template>
<div>
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
            <stats-card header-color="blue">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-money-check-alt"></i>
                    </div>
                    <h4 class="title">
                    TOTAL VENDIDO
                    </h4>
                </template>

                <template slot="footer">
                    <div class="stats">
                        {{ homeFornecedor.total }}
                    </div>
                </template>
            </stats-card>
        </div>     

        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
            <stats-card header-color="green">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-money-check-alt"></i>
                    </div>
                    <h4 class="title">
                    TOTAL A RECEBER
                    </h4>
                </template>

                <template slot="footer">
                    <div class="stats">
                        {{ homeFornecedor.receber }}
                    </div>
                </template>
            </stats-card>
        </div>   
    </div>
</div>
</template>

<script>
import {
    StatsCard,
    AnimatedNumber
} from "@/components";
import Notify from '@/config/mixins/notify'

export default {
    components: {
        StatsCard
    },

    data() {
        return {
            homeFornecedor: {}
        };
    },

    created() {
        this.getHomeFornecedor();
    },

    mixins: [Notify],

    methods: {
        getHomeFornecedor() {
            this.$http.get(this.$urlAPI + 'pagamentos/total-fornecedor')
                .then(response => {
                    if(response.data.status){
                        this.homeFornecedor = response.data.dados
                    } else{
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        }
    },
};
</script>
